import React, { useState } from "react";
import { Box, Rating, Typography } from "@mui/material";

const StarRating = ({ label, value, onChange, required, max = 5, readOnly = false }) => {
  const [hover, setHover] = useState(-1);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.5 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 500, color: "#333", display: "flex", alignItems: "center" }}>
        {label}
        {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Rating
          name={label}
          value={value}
          max={max}
          readOnly={readOnly}
          size="large"
          onChange={(event, newValue) => { if (newValue !== null) onChange(newValue); }}
          onChangeActive={(event, newHover) => setHover(newHover)}
          sx={{
            fontSize: "2rem",
            "& .MuiRating-iconFilled": { color: "#f5a623" },
            "& .MuiRating-iconHover": { color: "#ffb400" },
          }}
        />
        <Typography variant="body2" sx={{ color: "#666", minWidth: 40 }} aria-live="polite">
          {hover !== -1 ? `${hover}/${max}` : value ? `${value}/${max}` : `Choose 1–${max}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default StarRating;
